import FinanceHelpLabel from "../../finance/FinanceHelpLabel";

type LotNumberReport =
  | "employeeWeighing"
  | "financeProduction"
  | "productionDetail"
  | "productionSummary";

type ReportLotNumberLabelProps = {
  report: LotNumberReport;
  htmlFor: string;
};

const helpByReport: Record<LotNumberReport, string> = {
  employeeWeighing:
    "Enter the exact lot number printed on production labels created by the selected weighing user within the chosen dates.",
  financeProduction:
    "Enter an exact production or field lot number to review its input cost, output quantity, cost per unit, and yield. Leave this blank to include all lots in the selected period.",
  productionDetail:
    "Use the lot number printed on the product label, for example NV280726101. Leave this blank to include all lots within the selected dates.",
  productionSummary:
    "Enter the exact finished-product lot number you want summarized within the chosen dates.",
};

export default function ReportLotNumberLabel({
  report,
  htmlFor,
}: ReportLotNumberLabelProps) {
  return (
    <span className="inline-flex items-center gap-1.5 align-middle">
      <label htmlFor={htmlFor} className="block text-sm font-medium text-brand">
        Lot number
      </label>
      <FinanceHelpLabel
        label="Lot number"
        help={helpByReport[report]}
        labelVisible={false}
      />
    </span>
  );
}
